// Hook pra modais com overlay clicável — evita fechar quando o usuário
// seleciona texto dentro e arrasta o mouse pra fora. Só fecha quando o gesto
// inteiro (mousedown E click) aconteceu DIRETO no overlay. Ver centrao-docs/02.
import { useRef } from 'react';

export function useModalSafeClose(onFechar) {
  const downNoOverlay = useRef(false);
  return {
    overlayProps: {
      onMouseDown: (e) => { downNoOverlay.current = e.target === e.currentTarget; },
      onClick: (e) => {
        if (e.target === e.currentTarget && downNoOverlay.current) onFechar?.();
        downNoOverlay.current = false;
      },
    },
    contentProps: {},
  };
}

export default useModalSafeClose;
